export default "__VITE_ASSET__B0JmH6WE__"